import { render } from "./UnitType2List.vue?vue&type=template&id=2a180d1e&scoped=true"
import script from "./UnitType2List.vue?vue&type=script&lang=js"
export * from "./UnitType2List.vue?vue&type=script&lang=js"

import "./UnitType2List.vue?vue&type=style&index=0&id=2a180d1e&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a180d1e"]])

export default __exports__